"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateDiff = dateDiff;
const TimeSpan_1 = require("../TimeSpan");
/**
 * Oblicza różnicę pomiędzy datami
 * @param lateDate data późniejsza
 * @param earlyDate data wcześniejsza
 */
function dateDiff(lateDate, earlyDate) {
    return TimeSpan_1.TimeSpan.diff(lateDate, earlyDate);
}
//# sourceMappingURL=dateDiff.js.map